var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LegalPageLayout',{attrs:{"title":_vm.$t('wayver and release').toString(),"content":_vm.wayverAndRelease}})}
var staticRenderFns = []

export { render, staticRenderFns }